import { useState } from "react";
import moment from "moment";
import Datepicker from "components/shared/Datepicker/Datepicker";
import { PURCHASE_ORDER_STATUSES } from "./config";
import StatusMultiSelectBox from "./StatusMultiSelectBox";
import FilterDateTrigger from "./FilterDateTrigger";
import WarehouseMultiSelectBox from "./WarehouseMultiSelectBox";
import {
  FiltersCard,
  FiltersTitle,
  FiltersRow,
  FilterField,
  FilterLabel,
  FiltersActions,
  ApplyFiltersButton,
  ClearAllButton,
} from "./styles.purchaseOrderListDesktop";

const ALL_STATUSES = Object.values(PURCHASE_ORDER_STATUSES);

export default function PurchaseOrderFilters({
  selectedStatuses,
  onToggleStatus,
  selectedDeliveryDate,
  onDeliveryDateChange,
  selectedWarehouses,
  onToggleWarehouse,
  onApply,
  onClear,
}) {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <FiltersCard>
      <FiltersTitle>Filters</FiltersTitle>
      <FiltersRow>
        <FilterField>
          <FilterLabel>Status</FilterLabel>
          <StatusMultiSelectBox statuses={ALL_STATUSES} selected={selectedStatuses} onToggle={onToggleStatus} />
        </FilterField>
        <FilterField>
          <FilterLabel>Delivery date</FilterLabel>
          <Datepicker
            selected={selectedDeliveryDate}
            onChange={(date) => {
              onDeliveryDateChange(date);
              setPickerOpen(false);
            }}
            open={pickerOpen}
            onInputClick={() => setPickerOpen(true)}
            onClickOutside={() => setPickerOpen(false)}
            customInput={
              <FilterDateTrigger value={selectedDeliveryDate ? moment(selectedDeliveryDate).format("DD MMM 'YY") : ""} />
            }
          />
        </FilterField>
        <FilterField>
          <FilterLabel>Delivery location</FilterLabel>
          <WarehouseMultiSelectBox selected={selectedWarehouses} onToggle={onToggleWarehouse} />
        </FilterField>
      </FiltersRow>
      <FiltersActions>
        <ApplyFiltersButton type="button" onClick={onApply}>
          Apply filters
        </ApplyFiltersButton>
        <ClearAllButton type="button" onClick={onClear}>
          Clear all
        </ClearAllButton>
      </FiltersActions>
    </FiltersCard>
  );
}
